import { FaThList, FaMapPin, FaNetworkWired } from 'react-icons/fa'
import EmailIcon from '@mui/icons-material/Email';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { BsTelegram, BsClock } from 'react-icons/bs'
import { CiFlag1 } from 'react-icons/ci'
import switzerland_img from '../../assets/Image/Switzerland_img.svg'
import { HiOutlineBuildingOffice } from 'react-icons/hi2';
import { AiOutlineQuestionCircle } from 'react-icons/ai';


const About_Hover = () => {
    let icons = [
        {
            icon: <EmailIcon className='navbar_icon' />,
        },
        {
            icon: <TwitterIcon className='navbar_icon' />,
        },
        {
            icon: <YouTubeIcon className='navbar_icon' />,
        },
        {
            icon: <LinkedInIcon className='navbar_icon' />,
        },
        {
            icon: <BsTelegram className='navbar_icon' />,
        },
    ]

    let aboutIcons = [
        {
            icon_s: <HiOutlineBuildingOffice />,
            title: 'COMPANY',
            para: 'Discover our mission, vision, and values, as we collaborate to create innovative solutions and make a positive impact in our industry.'
        },
        {
            icon_s: <FaNetworkWired />,
            title: 'HOW WE WORK',
            para: 'Explore our unique approach, combining teamwork, open communication, and a customer - centric mindset to achieve success and drive meaningful progress.'
        },
        {
            icon_s: <AiOutlineQuestionCircle />,
            title: 'FAQ',
            para: 'Find clear, concise answers to common queries, addressing your concerns and providing valuable insights to enhance your experience.'
        },
    ]
    return (
        <>
            <div className='navbar_hover_main_div'>
                <div className='navbar_hover_div'>
                    <div className='navbar_hover_inner_div'>
                        <div className='list_icon_div'>
                            <FaThList />
                        </div>
                        <h3>ABOUT US</h3>
                    </div>
                    <div className="navbar_hover_inner_div3">
                        <div className='about_located_icon_div'>
                            <div className='about_inner_icon_div'>
                                <div><BsClock className='about_located_icon' /></div>
                                <div className='about_inner_p_div2'>
                                    <p>
                                        Covering most timezones
                                    </p>
                                </div>
                            </div>
                            <div className='about_inner_icon_div'>
                                <div><CiFlag1 className='about_located_icon' /></div>
                                <div className='about_inner_p_div2'>
                                    <p>
                                        Working with teams of diverse backgrounds
                                    </p>
                                </div>
                            </div>
                            <div className='about_inner_icon_div'>
                                <div><FaMapPin className='about_located_icon' /></div>
                                <div className='about_inner_p_div2'>
                                    <p>
                                        Based in Zug, Switzerland
                                    </p>
                                </div>
                            </div>
                        </div>
                        <p>We are a global company that partners with organizations around the world to provide innovative solutions to complex challenges. Our team is comprised of experts from diverse backgrounds who are passionate about helping our clients reach their goals. We focus on developing and implementing strategies that drive growth and success both on a local and worldwide scale.</p>
                        <div className='swit_div'>
                            <img src={switzerland_img} alt="" />
                            <p>Zug, Switzerland</p>
                        </div>
                    </div>
                    <div>
                        {
                            icons?.map((v, i) => {
                                return (
                                    <>
                                        <div className='navbar_icon_inner_div'>
                                            {v?.icon}
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='navbar_hover_div3'>
                    {
                        aboutIcons?.map((v, i) => {
                            return (
                                <div className='nav_hover_card2 flip-card'>
                                        <div class="flip-card-inner">

                                    <div className='nav_hover_icon_div'>
                                        {v?.icon_s}
                                    </div>
                                    <div className='nav_hover_text_div' >
                                        <h3>
                                            {v?.title}
                                        </h3>
                                    </div>
                                        <div className='nav_hover_card_p2 flip-card-back'>
                                        <p>
                                            {v?.para}
                                        </p>
                                    </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className='navbar_hover_div4'>
                    <iframe
                        title="Baarerstrasse 82, 6302 Zug, Switzerland"
                        loading="lazy"
                        src="https://maps.google.com/maps?q=Baarerstrasse%2082%2C%206302%20Zug%2C%20Switzerland&amp;t=m&amp;z=11&amp;output=embed&amp;iwloc=near"
                        width="100%"
                        height="430"
                        style={{ border: 0 ,borderRadius: '8px'}}
                        allowFullScreen
                    ></iframe>
                </div>
            </div>

        </>
    )
}
export default About_Hover